/**
 * Safely stringify values for DST save payloads.
 * Prevents TypeError when attMap-loaded fields or entity properties are undefined.
 */
export function toSaveString(value: unknown, fallback = ''): string {
  if (value === null || value === undefined) {
    return fallback;
  }
  return String(value);
}

export function safeEntityField(
  entity: object | null | undefined,
  field: string
): string {
  if (!entity) {
    return '';
  }
  const val = (entity as Record<string, unknown>)[field];
  return val === null || val === undefined ? '' : String(val);
}

export function safeEntityId(entity: object | null | undefined): string {
  return safeEntityField(entity, 'ENTITYID');
}
